/** GPS fix-age health classification and watchdog restart policy for flight recording. */

export const GPS_STALE_THRESHOLD_MS = 15_000;
export const GPS_LOST_THRESHOLD_MS = 60_000;
/** No fix for this long while recording → restart the GPS watcher (and at most once per interval). */
export const GPS_WATCHDOG_STALL_MS = 30_000;

export type GpsHealth = 'ok' | 'stale' | 'lost';

export function gpsHealthFromFixAge(fixAgeMs: number | null): GpsHealth {
  if (fixAgeMs == null || fixAgeMs < GPS_STALE_THRESHOLD_MS) return 'ok';
  if (fixAgeMs < GPS_LOST_THRESHOLD_MS) return 'stale';
  return 'lost';
}

export function shouldRestartGpsWatcher(params: {
  nowMs: number;
  lastFixAtMs: number | null;
  lastRestartAtMs: number;
  isRecording: boolean;
  isPaused: boolean;
  restartInFlight: boolean;
}): boolean {
  const { nowMs, lastFixAtMs, lastRestartAtMs, isRecording, isPaused, restartInFlight } = params;
  if (!isRecording || isPaused || restartInFlight) return false;
  if (lastFixAtMs == null) return false;
  if (nowMs - lastFixAtMs < GPS_WATCHDOG_STALL_MS) return false;
  if (nowMs - lastRestartAtMs < GPS_WATCHDOG_STALL_MS) return false;
  return true;
}
